import React from 'react';
import { FormGroup, Input, Button } from 'reactstrap';
import { Trash2 } from 'react-feather';

const PITTI_CSV_COLUMNS = [
  { id: 'type', label: 'Type (brand/retailer)', required: true },
  { id: 'pitti_id', label: 'Pitti ID', required: true },
  { id: 'email', label: 'Email', required: true },
  { id: 'personal_name', label: 'Name', required: true },
  { id: 'password', label: 'Password', required: true },
  { id: 'role', label: 'Role', required: false },
  { id: 'phone', label: 'Phone', required: false },
];

const BulkCsvColumnMapperItem = ({
  table,
  appendableColumns,
  onTableColumnSelect,
  onTableColumnUnSelect,
}) => {
  return (
    <div
      className="mt-3 px-3 px-sm-4 py-3 w-100"
      style={{
        borderRadius: '5px',
        minHeight: '100px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #dee2e6',
        display: 'flex',
        flexDirection: window.innerWidth < 576 ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <div
        className="d-flex flex-column flex-sm-row align-items-center w-100 justify-content-between"
        style={{ flex: 1 }}
      >
        {/* File Header */}
        <div className="d-block d-sm-none w-100" style={{ fontSize: '12px', fontWeight: 500, color: '#697277' }}>
          FILE HEADER
        </div>
        <div
          className="w-100"
          style={{
            flex: 1,
            fontSize: window.innerWidth < 576 ? '14px' : '16px',
            fontWeight: 500,
            textTransform: 'uppercase',
          }}
        >
          {table.column}
        </div>

        {/* Sample Data */}
        <div className="mt-2 d-block d-sm-none w-100" style={{ fontSize: '12px', fontWeight: 500, color: '#697277' }}>
          DATA
        </div>
        <div className="w-100" style={{ flex: 1, overflow: 'hidden' }}>
          {table.data.map((d, i) => (
            <div
              key={i}
              style={{
                color: '#303334',
                fontSize: window.innerWidth < 576 ? '13px' : '14px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '180px',
              }}
            >
              {d}
            </div>
          ))}
          {table.data.length > 0 && <span style={{ color: '#999', fontSize: '12px' }}>...</span>}
        </div>
      </div>

      {/* Mapped value or dropdown */}
      {table?.appendedValue ? (
        <div className="d-flex align-items-center" style={{ flex: 0.5, width: '100%' }}>
          <div style={{ textAlign: 'center', flex: 0.8, fontSize: '14px', fontWeight: 500 }}>
            {PITTI_CSV_COLUMNS.find((c) => c.id === table.appendedValue)?.label || table.appendedValue}
          </div>
          <Button
            color="link"
            className="p-0"
            onClick={() => onTableColumnUnSelect(table.column)}
          >
            <Trash2 size={18} />
          </Button>
        </div>
      ) : (
        <div className="w-100 w-sm-auto mt-2 mt-sm-0" style={{ flex: 0.5 }}>
          <div className="d-block d-sm-none mb-2" style={{ fontSize: '14px', color: '#303334', fontWeight: 500 }}>
            MAP TO FIELD
          </div>
          <FormGroup className="mb-0">
            <Input
              type="select"
              style={{
                backgroundColor: 'white',
                color: '#4E585E',
                fontWeight: 500,
                fontSize: '14px',
              }}
              onChange={(e) => onTableColumnSelect(table.column, e.target.value)}
            >
              <option value="">Select</option>
              {appendableColumns
                ?.sort((_, b) => (b?.required ? 1 : -1))
                ?.map((column) => (
                  <option key={column.id} value={column.id}>
                    {column.label}
                    {column.required ? ' *' : ''}
                  </option>
                ))}
            </Input>
          </FormGroup>
        </div>
      )}
    </div>
  );
};

export { PITTI_CSV_COLUMNS };
export default BulkCsvColumnMapperItem;
